import { Injectable } from '@angular/core';
/**
 * Classe utilitaire pour les téléchargement.
 */
@Injectable()
export class DownloadHelper {
    /**
     * Télécharge un fichier sur le poste client.
     * @param blob: Contenu du fichier.
     * @param fileName: Nom du fichier.
     */
    public downloadFile(blob: Blob, fileName: string) {
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            // for IE
            (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
        } else {
            // for Non-IE (chrome, firefox etc.)
            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.target = '_blank';
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
        }
    }
}
